import { IgChip } from "@intelligems/ig-theme/IgChip";
import {
  IgCoreTextColors,
  IgInteractiveBackgroundColors,
  IgTonalBackgroundColors,
  IgTonalTextColors,
} from "@intelligems/ig-design-tokens/constants";

export type NavBadgeTone = "accent" | "warning";

const TONE_SX = {
  accent: {
    backgroundColor: IgInteractiveBackgroundColors.accent.default,
    color: IgCoreTextColors.dark,
    fontWeight: 400,
  },
  warning: {
    backgroundColor: IgTonalBackgroundColors.warning,
    color: IgTonalTextColors.warning,
    fontWeight: 600,
  },
};

export const NavBadge = ({
  label,
  tone = "accent",
}: {
  label: string;
  tone?: NavBadgeTone;
}) => (
  <IgChip
    color="default"
    label={label}
    size="small"
    sx={{
      ...TONE_SX[tone],
      height: "20px !important",
      "& .MuiChip-label": {
        px: 1,
      },
    }}
  />
);
